import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { enqueueSnackbar } from '../redux/notifier/actions';
import useGlobalLoader from './useGlobalLoader';

function useApiCall(promise, options = {}) {
  const {
    successMessage,
    errorMessage,
    disableGlobalLoader = false,
  } = options;
  const dispatch = useDispatch();
  const {
    startContextLoading,
    stopContextLoading,
    setGlobalLoaderEnabled,
  } = useGlobalLoader();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (disableGlobalLoader) setGlobalLoaderEnabled(false);
    return () => {
      if (disableGlobalLoader) setGlobalLoaderEnabled(true);
    };
  }, [disableGlobalLoader, setGlobalLoaderEnabled]);

  const handleError = (err) => {
    if (err.status === 404 || err.status === 503) {
      throw new Error(err.message);
    } else if (err.status === 403 && err?.method === 'GET') {
      throw new Error('ERR_NOT_FOUND');
    } else {
      dispatch(enqueueSnackbar({
        message: errorMessage || err.message,
        options: {
          variant: 'error',
          cause: err.cause,
        },
      }));
    }
  };

  const makeApiCall = async (...args) => {
    try {
      if (!disableGlobalLoader) startContextLoading();
      setIsLoading(true);

      const response = await promise(...args);
      const { data = 'success' } = response;

      if (successMessage) {
        dispatch(enqueueSnackbar({
          message: successMessage,
          options: { variant: 'success' },
        }));
      }
      if (!disableGlobalLoader) stopContextLoading();
      setIsLoading(false);
      return [data, null];
    } catch (err) {
      if (!disableGlobalLoader) stopContextLoading();
      setIsLoading(false);
      handleError(err);
      return [null, err];
    }
  };
  makeApiCall.isLoading = isLoading;
  return makeApiCall;
}

export default useApiCall;
